<template>
  <div>
    <Flex
      direction="column"
      :gap="0.25"
    >
      <BaseHeading>
        {{ $t('marketing.email.automated_emails.title') }}
      </BaseHeading>
      <BaseText>
        {{ $t('marketing.email.automated_emails.description') }}
      </BaseText>
    </Flex>
    <Flex
      :class="$style.inner"
      wrap
    >
      <TemplateCard
        :title="$t('marketing.email.automated_emails.rebook.title')"
        :description="$t('marketing.email.automated_emails.rebook.description')"
        :enabled="rebookReminderEnabled"
        :routerLink="{ name: 'rebook-reminder-dashboard' }"
      />
      <TemplateCard
        :title="$t('marketing.email.automated_emails.waiting_list.title')"
        :description="
          $t('marketing.email.automated_emails.waiting_list.description')
        "
        :enabled="waitingListEnabled"
        :routerLink="{ name: 'waiting-list-template' }"
      />
      <TemplateCard
        :title="$t('marketing.email.automated_emails.birthday.title')"
        :description="
          $t('marketing.email.automated_emails.birthday.description')
        "
        :enabled="birthdayMessageEnabled"
        :routerLink="{ name: 'birthday-template' }"
      />
      <TemplateCard
        :title="$t('marketing.email.automated_emails.online_forms.title')"
        :description="
          $t('marketing.email.automated_emails.online_forms.description')
        "
        :enabled="true"
        :routerLink="{ name: 'online-forms' }"
        v-intercom="'marketing-email-forms-card'"
      />
    </Flex>
  </div>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import { defineComponent } from 'vue';
import { useCompanyStore } from '@/stores/company';
import { useServicesStore } from '@/stores/services';
import { useUserStore } from '@/stores/user';
import TemplateCard from './TemplateCard.vue';

export default defineComponent({
  components: {
    TemplateCard,
  },
  computed: {
    ...mapState(useCompanyStore, ['companySettings']),
    ...mapState(useUserStore, ['hasFeatureFlag']),
    rebookReminderEnabled() {
      const { rebookEnabledServicesCount } = useServicesStore();
      return (
        this.companySettings.bookings.rebookReminderEnabled &&
        rebookEnabledServicesCount > 0
      );
    },
    waitingListEnabled() {
      return this.companySettings.bookings.waitingListEnabled;
    },
    birthdayMessageEnabled() {
      return this.companySettings.customers.birthdayMessageEnabled;
    },
  },
});
</script>

<style
  lang="scss"
  module
>
.inner {
  display: flex;
  flex-wrap: wrap;
  margin-top: $spacing;
}
</style>
